export default __webpack_public_path__ + "static/media/Turtles.43dc2721.png";